<template>
  <v-container fluid>
    <h1 class="display-inline">Jobs Time Planner</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <v-row>
      <v-col cols="12">
        <JobsNavigator @jobChanged="jobChanged"></JobsNavigator>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <JobsTimePlanner :jobId="selectedJob" @updatedTasks="tasks=$event"></JobsTimePlanner>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import JobsNavigator from "../components/jobs/JobsNavigator"
import JobsTimePlanner from "../components/job/JobTimePlanner"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "JobTimePlannerPage",
  permissions: [...JobsTimePlanner.permissions, ...JobsNavigator.permissions],
  components: {
    ActiveApiCalls,
    JobsTimePlanner, JobsNavigator
  },
  methods: {
    jobChanged: function (jobId) {
      this.selectedJob = jobId
    }
  },
  mounted() {
  },
  data() {
    return {
      selectedJob: "",
      tasks: []
    }
  },
}

</script>

<style scoped>

</style>